export function getInitialsFromName(name?: string): string {
    if (!name) return '';

    const parts = name.trim().split(' ');
    if (parts.length === 0) return '';

    const first = parts[0][0]?.toUpperCase() || '';
    const last = parts[parts.length - 1][0]?.toUpperCase() || '';

    return first + last;
}

type ClassValue = string | undefined | null | false | Record<string, boolean>;

export function clsx(...classes: ClassValue[]): string {
    return classes.reduce((classes, cls) => {
        if (!cls) return classes;
        if (typeof cls === 'string') return classes.concat(cls);
        if (Array.isArray(cls)) return classes.concat(clsx(...cls));
        if (typeof cls === 'object') {
            return classes.concat(
                Object.entries(cls)
                    .filter(([_, value]) => Boolean(value))
                    .map(([key, _]) => key)
            );
        }
        return classes;
    }, new Array<ClassValue>()).join(' ');
}
